@if (authService.user$ | async; as user) {
  @if (layout === 'desktop') {
    @if (downloadService.download) {
      <app-tooltip
        alignment="bottom"
        [instantOpen]="true"
        >
        <div class="download-manager" label>
          @if (downloadService.download.percentage !== 100) {
            <span class="download-manager__badge">
              {{ downloadTrackerService.getPendingDownloads().length }}
            </span>
            <app-spinner></app-spinner>
          }
          @if (downloadService.download.percentage === 100) {
            <span
              appIcon="check-circle"
            ></span>
          }
          <span class="download-manager__label">
            {{ 'products.downloads' | translate }}
          </span>
        </div>
        <div class="download-manager__spinner-container">
          @if (downloadService.download.percentage !== 100) {
            <div class="download-manager__spinner"></div>
            <p>
              <span class="download-manager__percentage-text">{{ downloadService.download.percentage}}%</span>
            </p>
          }
          @if (downloadService.download.percentage === 100) {
            <span appIcon="download"
              class="download-manager__check-icon"
            ></span>
          }
        </div>
        <div class="text-center download-manager__tooltip-text-container">
          @if (downloadTrackerService.getPendingDownloads().length > 1) {
            <p class="download-manager__pending-downloads">
              {{ 'download-service.pending-downloads' | translate : {
              downloads: downloadTrackerService.getPendingDownloads().length - 1
            }
            }}
          </p>
        }
        <hr class="download-manager__divider" />
        @if (downloadService.download.percentage !== 100) {
          <p class="text-white">
            {{ 'download-service.processing-your-download' | translate }}
          </p>
          {{ 'download-service.processing-your-download-explanation' | translate: { email: user.email} }}
        }
        @if (downloadService.download.percentage === 100) {
          <p class="text-white">
            {{ 'download-service.download-succeeded' | translate }}
          </p>
          {{ 'download-service.download-succeeded-explanation' | translate: { email: user.email} }}
        }
      </div>
    </app-tooltip>
  }
}
@if (layout === 'mobile' && downloadService.download) {
  <div class="download-manager">
    <span class="download-manager__label">{{ 'products.downloads' | translate }}</span>
    @if (downloadService.download.percentage !== 100) {
      <div
        class="download-manager__mobile"
        >
        <p>
          {{ downloadService.download.percentage}}%
        </p>
        <app-spinner></app-spinner>
        <span class="download-manager__badge">
          {{ downloadTrackerService.getPendingDownloads().length }}
        </span>
      </div>
    }
    @if (downloadService.download.percentage === 100) {
      <span
        appIcon="check-circle"
      ></span>
    }
  </div>
  <div class="download-manager__spinner-container">
    @if (downloadService.download.percentage !== 100) {
      <p>
        <span class="download-manager__percentage-text">{{ downloadService.download.percentage}}%</span>
      </p>
    }
  </div>
}
}
